/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileBin = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M4 2h10.414L20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4zm11 3.414V7h1.586z" />
        <path d="M11.052 17v-4.87h1.708c.621 0 1.077.104 1.367.314.295.21.442.536.442.978 0 .22-.058.416-.174.59a1.222 1.222 0 0 1-.482.415c.576.179.864.56.864 1.146 0 .951-.659 1.427-1.977 1.427zm1.005-2.854h.509c.353 0 .6-.045.744-.134.147-.094.22-.25.22-.47 0-.227-.07-.386-.214-.475-.143-.094-.393-.14-.75-.14h-.51zm0 2.05h.663c.344 0 .596-.054.757-.16s.241-.276.241-.503c0-.224-.08-.387-.24-.49s-.414-.153-.758-.153h-.663zm3.372.804v-4.87h1.045V17zm1.995 0v-4.87h.965l2.104 3.168V12.13h1.032V17h-.965l-2.104-3.176V17z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileBin as FileBin };
